import React , {useState, useEffect} from "react";
//import ReactDOM from "react-dom";
//import { Accordion, AccordionTab } from "primereact/accordion";
import  "./Category.css";
const category =(props) =>{
  
    var targetType="_self";
  
    let items= props.items.map((item,index)=>{
  
        targetType = !!item.Target ? item.Target : "_self";
        return <div className="footerItem" key={"Category_"+index}>
                <a href={item.NavigateUrl} target={targetType} ><div>{item.Text}</div></a>
            </div>
     });

    return (
         <li className={`col-12 col-md-${props.wide} footer-category-warpper`}>
              <div>
                    <div>{

                    items
                    }</div>
                </div>
            </li>
    )
}


export default category;